import React, { Component, createRef } from 'react'
import { connect } from 'react-redux'
import saveAs from 'file-saver';
import { jsPDF } from 'jspdf';
import { setVerifyInputFile, setVerifyDSInputFile, clearVerifyInputFile,
		clearVerifyDSInputFile, clearVerifyResultData, clearFileSignedData, setVerifyDSExpand, clearModifiedDSData, setIsLoading, setSignatureDifferenceType,
		clearSignatureDifferenceType, setShowPreviewPopupVerify, setShowUpgradeCard } from '../../actions/localStates'

import { checkExtensionVerify, fromBytes } from '../../actions/stringEncodersFuncs'
import { bindActionCreators } from 'redux'
import i18next from 'i18next'

import '../../fonts/Roboto-Regular-normal.js';
import '../../fonts/Roboto-Regular-bold.js';
import '../../fonts/Roboto-Bold-normal.js';

import '../../fonts/Hauora-ExtraBold-bold.js';
import '../../fonts/Hauora-ExtraBold-normal.js';
import '../../fonts/Hauora-Regular-normal.js';
import '../../fonts/KharkivTone04_10_2020-normal.js';

// import html2pdf from 'html2pdf.js';

import VerifyDSOptionsContainer from '../../containers/VerifyDSOptionsContainer'
import VerifyTextDSContainer from '../../containers/VerifyTextDSContainer'

import PreviewPopup from '../../containers/PreviewPopup'

import PrivateSignPopup from './PrivateSignPopup'
import QRPopup from './QRPopup'

import Dropzone from 'react-dropzone';

const dropzoneRef = createRef();
const dropzoneDSRef = createRef();


class VerifyDSTab extends Component {

	constructor(props) {
	    super(props);
	    this.state = {
	    	isLoading: false,
	    	collapseVerifyDSShow: "",
	    	showPopup: false,
	    	displayedData: null
	    }

	    this.showDsVerifyResults = this.showDsVerifyResults.bind(this);
	    this.handleShowQR = this.handleShowQR.bind(this);

	    this.handleOnDrop = this.handleOnDrop.bind(this);
	    this.handleOnDropDS = this.handleOnDropDS.bind(this);

	    this.copyVerifyResults = this.copyVerifyResults.bind(this);
	    this.generateTextResult = this.generateTextResult.bind(this);

	    this.saveVerifyResultsToPdf = this.saveVerifyResultsToPdf.bind(this);

	    this.showPreviewPopupVerify = this.showPreviewPopupVerify.bind(this);
	    this.handleShowPrivateSign = this.handleShowPrivateSign.bind(this);
	}

	handleShowPrivateSign (base64Image) {
		var data;
        document.activeElement.blur();

        if (this.state.displayedData === null) {
			data = {
				fileName: this.props.defaultOptionState.signatureType === "attached" ? this.props.defaultState.fileWithDSName : this.props.defaultState.fileInputName,
				privateSignImage: base64Image
			}

			this.setState({
	        	displayedData: data
	        })
		} else {
			this.setState({
	        	displayedData: null
	        })
		}

        this.setState({
            showPrivateSignPopup: !this.state.showPrivateSignPopup
        });
    }

	handleShowQR (i) {
		var data;
        document.activeElement.blur();

        if (this.state.displayedData === null) {
			data = {
				fileName: this.props.defaultOptionState.signatureType === "attached" ? this.props.defaultState.fileWithDSName : this.props.defaultState.fileInputName,
				qrLink: this.props.defaultState.verifyResultsForQR[i]
			}

			this.setState({
	        	displayedData: data
	        })
		} else {
			this.setState({
	        	displayedData: null
	        })
		}

        this.setState({
            showPopup: !this.state.showPopup
        });
    }

	expandVerifyDS() {
		this.props.actions.setVerifyDSExpand(this.props.expandedCardsReducer.verifyExpanded)
		this.props.expandedCardsReducer.verifyExpanded ? this.setState({collapseVerifyDSShow: "card-body collapse"}) : this.setState({collapseVerifyDSShow: "card-body collapse show"})
	}

	buildFileInputSelector(){
		const fileInputSelector = document.getElementById('fileInputUpload');
		return fileInputSelector;
	}

	buildFileWithDSSelector(){
		const fileWithDSSelector = document.getElementById('fileWithDSUpload');
		return fileWithDSSelector;
	}

	componentDidMount(){
    	var dropFile = document.getElementById('dropFile');
		var dropDS = document.getElementById('dropDS');

    	this.fileInputSelector = this.buildFileInputSelector();
    	this.fileWithDSSelector = this.buildFileWithDSSelector();
    	this.props.expandedCardsReducer.verifyExpanded ? this.setState({collapseVerifyDSShow: "card-body collapse show"}) : this.setState({collapseVerifyDSShow: "card-body collapse"})

    	if (dropFile !== null) {
			dropFile.addEventListener('dragenter', function(event) {
				dropFile.style.border = "2px solid steelblue";
			}, false);

			dropFile.addEventListener('dragover', function(event) {
				dropFile.style.border = "2px solid steelblue";
			}, false);

			dropFile.addEventListener('dragleave', function(event) {
				dropFile.style.border = "";
			}, false);
		}

		if (dropDS !== null) {
			dropDS.addEventListener('dragenter', function(event) {
				dropDS.style.border = "2px solid steelblue";
			}, false);

			dropDS.addEventListener('dragover', function(event) {
				dropDS.style.border = "2px solid steelblue";
			}, false);

			dropDS.addEventListener('dragleave', function(event) {
				dropDS.style.border = "";
			}, false);
		}
	}

	componentDidUpdate(prevProps) {
		var dropFile = document.getElementById('dropFile');
		var dropDS = document.getElementById('dropDS');

		if (prevProps.signatureType !== this.props.defaultOptionState.signatureType) {
			this.fileInputSelector = this.buildFileInputSelector();
		}

		if (this.state.isLoading && (this.props.defaultState.verifyResults || this.props.defaultState.verifyResults === undefined)) {
			this.setState({isLoading: false})
		}

		if (prevProps.fileInputSelected !== this.props.defaultState.fileInputSelected) {
			if (dropFile !== null) {
				dropFile.addEventListener('dragenter', function(event) {
					dropFile.style.border = "2px solid steelblue";
				}, false);

				dropFile.addEventListener('dragover', function(event) {
					dropFile.style.border = "2px solid steelblue";
				}, false);

				dropFile.addEventListener('dragleave', function(event) {
					dropFile.style.border = "";
				}, false);
			}
		}

		if (prevProps.fileWithDSSelected !== this.props.defaultState.fileWithDSSelected) {
			if (dropDS !== null) {
				dropDS.addEventListener('dragenter', function(event) {
					dropDS.style.border = "2px solid steelblue";
				}, false);

				dropDS.addEventListener('dragover', function(event) {
					dropDS.style.border = "2px solid steelblue";
				}, false);

				dropDS.addEventListener('dragleave', function(event) {
					dropDS.style.border = "";
				}, false);
			}
		}
	}

	handleFileInputSelect(e) {
		e.preventDefault();
		this.fileInputSelector.value = null;
	    this.fileInputSelector.click()
	    document.activeElement.blur()
	    this.props.actions.clearVerifyResultData()
	    this.props.actions.clearFileSignedData()
	    this.props.actions.clearModifiedDSData()
	    this.props.actions.clearSignatureDifferenceType()
	}

	handleFileWithDSSelect(e) {
	    e.preventDefault();
	    this.fileWithDSSelector.value = null;
	    this.fileWithDSSelector.click()
	    document.activeElement.blur()
	    this.props.actions.clearVerifyResultData()
	    this.props.actions.clearModifiedDSData()
	    this.props.actions.clearFileSignedData()
	    this.props.actions.clearSignatureDifferenceType()
	}

	onChangeInput(e) {
		if (e.target.files[0] !== undefined && (e.target.files[0].size < 104857600)) {
			this.props.actions.setVerifyInputFile(e.target.files[0])
		}
	}

	handleOnDrop (files) {
		if (files[0] !== undefined && (files[0].size < 104857600)) {
			this.props.actions.setVerifyInputFile(files[0])
		}
	}

	onChangeDS(e) {
		if (e.target.files[0] !== undefined && (e.target.files[0].size < 104857600)) {
			this.props.actions.setVerifyDSInputFile(e.target.files[0])
		}
	}

	handleOnDropDS (files) {
		if (files[0] !== undefined && (files[0].size < 104857600)) {
			this.props.actions.setVerifyDSInputFile(files[0])
		}
	}

	setInputState() {
		this.props.actions.clearVerifyResultData()
		this.props.actions.setIsLoading(true);
		this.props.setInputs()
	}

	cleanUpFileInputSelect(){
		this.props.actions.clearVerifyResultData()
		this.props.actions.clearVerifyInputFile()
		this.props.actions.clearFileSignedData()
		this.props.actions.clearModifiedDSData()
	}

	cleanUpFileWithDSSelect(){
		this.props.actions.clearVerifyResultData()
		this.props.actions.clearVerifyDSInputFile()
		this.props.actions.clearModifiedDSData()
		this.props.actions.clearFileSignedData()
	}

	downloadModifiedData() {
		if (this.props.defaultState.fileInputName.length > 0) {
			saveAs(this.props.upgradeReducer.modifiedDSData, this.props.defaultState.fileInputName + ".p7s")
		} else {
			saveAs(this.props.upgradeReducer.modifiedDSData, this.props.defaultState.fileWithDSName)
		}
	}

	verifyModifiedData () {
		var fileName;

		if (this.props.defaultState.fileInputName.length > 0) {
			fileName = this.props.defaultState.fileInputName + ".p7s"
		} else {
			fileName = this.props.defaultState.fileWithDSName
		}
    	saveAs(this.props.upgradeReducer.modifiedDSData, fileName)

		function blobToFile(blob, fileName, mimeType = blob.type) {
		    return new File([blob], fileName, { type: mimeType });
		}

		const blob = new Blob([this.props.upgradeReducer.modifiedDSData], { type: "application/pkcs7-signature" });
		const file = blobToFile(blob, fileName);

		this.props.actions.setShowUpgradeCard(false)
		this.props.actions.setVerifyDSInputFile(file)
		this.props.actions.setIsLoading(true);
		this.props.setInputs()
	}

	downloadSignedData() {
		function removeTrailingP7sExtensions(filename) {
		  return filename.replace(/(?:\.p7s)+$/, '');
		}

        var dataFileName = removeTrailingP7sExtensions(this.props.defaultState.fileWithDSName)

    	saveAs(this.props.defaultState.fileSignedData, dataFileName)
	}

	cleanUpForm(){
		this.cleanUpFileInputSelect()
		this.cleanUpFileWithDSSelect()
		this.props.actions.clearVerifyResultData()
		this.props.actions.clearFileSignedData()
		this.props.actions.clearSignatureDifferenceType()
	}

	generateTextResult() {
		var strList = "", str = "", isValid;

		const safeDateParse = (inputData, invalidDate) =>
	    Date.parse(inputData) || invalidDate;

		const highestPriorityDate = (inputObject) =>
		    [
		        inputObject.signatureTimestamps.reduce(
		            (a, b) =>
		                Math.min(
		                    safeDateParse(a.dateTime, Number.MAX_SAFE_INTEGER),
		                    safeDateParse(b.dateTime, Number.MAX_SAFE_INTEGER)
		                ),
		            Number.MAX_SAFE_INTEGER
		        ),
		        safeDateParse(
		            inputObject.contentTimestamp.dateTime,
		            Number.MAX_SAFE_INTEGER
		        ),
		        Date.parse(inputObject.signingDateTime),
		    ].filter((a) => a !== Number.MAX_SAFE_INTEGER)[0];
		
		this.props.defaultState.verifyResults
        .sort((first, second) => {
            const firstHash = highestPriorityDate(first);
            const secondHash = highestPriorityDate(second);

            if (firstHash < secondHash) {
                return -1;
            }

            if (firstHash > secondHash) {
                return 1;
            }

            return 0;
        })
        .map(highestPriorityDate)

		for (var i = 0; i < this.props.defaultState.verifyResults.length; i += 1) {
			isValid = this.props.defaultState.verifyResults[i].isValid ? i18next.t("ds:heIsValid") : i18next.t("ds:heIsInvalid")
			str = i18next.t("ds:signature") + (i + 1) + ": " + isValid + "\n"

		    str += (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true") ? i18next.t("ds:qualifiedTitle") + "\n" : i18next.t("ds:unqualifiedTitle") + "\n"

			if (this.props.defaultState.verifyResults[i].status === "SUCCESS") {
				str += i18next.t("ds:signer") + this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerFullName.value + "\n"

				if (this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value) {
					str += i18next.t("ds:organizationName") + this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value + "\n"
				}

				if (this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value) {
					str += i18next.t("ds:title") + this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value + "\n"
				}
				
				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value) {
					str += i18next.t("ds:drfou") + this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value + "\n"
				}
				
				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value) {
					str += i18next.t("ds:edrpou") + this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value + "\n"
				}
		        
		        if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value) {
		        	str += i18next.t("ds:eddrun") + this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value + "\n"
		        }
		       	
		       	if (this.props.defaultState.verifyResults[i].signerInfo.certificateSerialNumber.value) {
		       		str += i18next.t("certificateSerialNumberTitle") + this.props.defaultState.verifyResults[i].signerInfo.certificateSerialNumber.value.replace(/\s/g, "") + "\n"
		       	}

		       	if (this.props.defaultState.verifyResults[i].signerInfo.issuerCertificateInfo.value.issuerFullName.value) {
		       		str += i18next.t("ds:ca") + this.props.defaultState.verifyResults[i].signerInfo.issuerCertificateInfo.value.issuerFullName.value + "\n"
		       	}

		       	if (this.props.defaultState.verifyResults[i].signingDateTime !== undefined && this.props.defaultState.verifyResults[i].signingDateTime.length > 0) {
		       		str += i18next.t("ds:dsDate") + this.formatDate(this.props.defaultState.verifyResults[i].signingDateTime) + "\n"
		       	}

		       	if (this.props.defaultState.verifyResults[i].contentTimestamp) {
		       		str += this.constructTimestampDetailsText(this.props.defaultState.verifyResults[i].contentTimestamp, "content")
		       	}

		       	if (this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps.length) {
					for (var j = 0; j < this.props.defaultState.verifyResults[i].signatureTimestamps.length; j += 1) {
						str += this.constructTimestampDetailsText(this.props.defaultState.verifyResults[i].signatureTimestamps[j], "signature")
					}
				}

				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isElectronicStamp.value.length > 0) {
					var isElectronicStampTitle = this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isElectronicStamp.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")
					str += i18next.t("ds:isElectronicStampTitle") + isElectronicStampTitle + "\n"
				}

				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value.length > 0) {
					var qualifiedCertTitle = this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")
					str += i18next.t("ds:qualifiedCertTitle") + qualifiedCertTitle + "\n"
				}

				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value.length > 0) {
					var QSCDTitle = this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")
					str += i18next.t("ds:QSCDTitle") + QSCDTitle + "\n"
				}

				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName) {
					var QSCDTypeTitle = this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value === null ? i18next.t("ds:notDefined") : this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value
					str += i18next.t("ds:QSCDTypeTitle") + QSCDTypeTitle + "\n"
				}

				if (this.props.defaultState.verifyResults[i].signatureType) {
					var signatureType = this.props.defaultState.verifyResults[i].signatureType === null ? i18next.t("ds:notDefined") : this.props.defaultState.verifyResults[i].signatureType
					str += i18next.t("ds:signatureType") + signatureType + "\n"
				}

				if (this.props.defaultState.verifyResults[i].signatureFormat) {
					var signatureFormat = this.props.defaultState.verifyResults[i].signatureFormat === null ? i18next.t("ds:notDefined") : this.props.defaultState.verifyResults[i].signatureFormat
					str += i18next.t("ds:" + signatureFormat) + "\n"
				}

				if (Object.keys(this.props.defaultState.verifyResults[i].contentTimestamp).length === 0 && this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps.length === 0) {
					str += i18next.t("ds:lawMsgFirstRow") + "\n"
					str += i18next.t("ds:lawMsgSecondRow") + "\n"
					str += i18next.t("ds:lawMsgThirdRow") + "\n"
				}

				// if (this.props.defaultState.verifyResults[i].failureCause !== undefined && this.props.defaultState.verifyResults[i].failureCause.length > 0) {
				// 	str += this.props.defaultState.verifyResults[i].failureCause
				// }
			} else {
				str += this.props.defaultState.verifyResults[i].failureCause
			}

			strList += str + "\n";
		}

		return strList;
	}

	copyVerifyResults() {
		var textArea,
        copy;

	    function isOS() {
	        return navigator.userAgent.match(/ipad|iphone/i);
	    }

	    function createTextArea(text) {
	        textArea = document.createElement('textArea');
	        textArea.value = text;
	        textArea.style.cssText = "position: absolute";
	        textArea.style.cssText = "top: -9999px";
	        document.body.appendChild(textArea);
	    }

	    function selectText() {
	        var range,
	            selection;

	        if (isOS()) {
	            range = document.createRange();
	            range.selectNodeContents(textArea);
	            selection = window.getSelection();
	            selection.removeAllRanges();
	            selection.addRange(range);
	            textArea.setSelectionRange(0, 999999);
	        } else {
	            textArea.select();
	        }
	    }

	    function copyToClipboard() {        
	        document.execCommand('copy');
	        document.body.removeChild(textArea);
	    }

	    copy = function(text) {
	        createTextArea(text);
	        selectText();
	        copyToClipboard();
	        document.getElementById("copyLink").style.color = "green";
	        window.setTimeout(function () {
	        	document.getElementById("copyLink").style.color = "#1a0dab";
	        }, 1500)
		};

		copy(this.generateTextResult());
	}

	saveVerifyResultsToPdf () {
		var isValid, doc = new jsPDF(), dateNow = new Date(), verticalOffset = 65, wrappedText, cleaned = "", archTimestampCounter = 0, dataFileName = "", tempOffset = 0, tempOffsetSecond = 0, maxWidth = 120, failureCauseSplited;
		var img = 'data:image/png;base64,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'

		const safeDateParse = (inputData, invalidDate) =>
	    Date.parse(inputData) || invalidDate;

		const highestPriorityDate = (inputObject) =>
		    [
		        inputObject.signatureTimestamps.reduce(
		            (a, b) =>
		                Math.min(
		                    safeDateParse(a.dateTime, Number.MAX_SAFE_INTEGER),
		                    safeDateParse(b.dateTime, Number.MAX_SAFE_INTEGER)
		                ),
		            Number.MAX_SAFE_INTEGER
		        ),
		        safeDateParse(
		            inputObject.contentTimestamp.dateTime,
		            Number.MAX_SAFE_INTEGER
		        ),
		        Date.parse(inputObject.signingDateTime),
		    ].filter((a) => a !== Number.MAX_SAFE_INTEGER)[0];
		
		this.props.defaultState.verifyResults
        .sort((first, second) => {
            const firstHash = highestPriorityDate(first);
            const secondHash = highestPriorityDate(second);

            if (firstHash < secondHash) {
                return -1;
            }

            if (firstHash > secondHash) {
                return 1;
            }

            return 0;
        })
        .map(highestPriorityDate)

		// doc.setFont('KharkivTone04_10_2020', 'normal');
		// doc.setFontSize(48);
		// doc.text("CIPHER", 10, 20);

		// var str = this.generateTextResult();

		function footer(){ 
			doc.setFont("Hauora-Regular", 'normal');
   			doc.setFontSize(10);
		    doc.text(198,292, doc.page.toString()); //print number bottom right
		    doc.page += 1;
		};

		doc.page = 1;

		footer()
		
		doc.addImage(img, 'PNG', 10, 10, 65, 17)
		doc.setFont('Hauora-Regular', 'normal');
		doc.setFontSize(8);

		doc.setTextColor("black");

		doc.setFont('Hauora-ExtraBold', 'bold');
   		doc.text(i18next.t("titlePdf"), 110, 15);
   		doc.text(i18next.t("addresTitlePdf"), 110, 19);

   		doc.setFont('Hauora-Regular', 'normal');
   		doc.text(i18next.t("streetAdddresPdf"), 122, 19);

   		// doc.setFont('Hauora-ExtraBold', 'bold');
   		// doc.text("Тел.:", 90, 23);

   		// doc.setFont('Hauora-Regular', 'normal');
   		// doc.text("+38 (044) 484-4612 |", 98, 23);
   		// doc.text("Факс: +38 (044) 483-0322", 100, 23);

   		doc.setFont('Hauora-ExtraBold', 'bold');
   		doc.text("E-mail:", 110, 23);

   		doc.setFont('Hauora-Regular', 'normal');
   		doc.text("nedp@ca.poltavabank.com", 121, 23);

   		doc.setFont('Hauora-ExtraBold', 'bold');
   		doc.text(i18next.t("webSitePdf"), 110, 27)
   		doc.textWithLink("ca.poltavabank.com", 125, 27, {url: 'ca.poltavabank.com'});
   		doc.line(10, 30, 200, 30);

   		doc.setFont('Hauora-ExtraBold', 'bold');
   		doc.setFontSize(18);
   		doc.setTextColor("black");
   		doc.text(i18next.t("clientTitlePdf"), 105, 40, {align:'center'});

   		doc.text(i18next.t("protocolTitlePdf"), 105, 48, {align:'center'});

   		doc.setFontSize(10);
   		doc.setFont('Hauora-Regular', 'normal');
   		doc.text(i18next.t("verifyTitlePdf"), 105, 53, {align:'center'});

   		doc.setFont("Hauora-ExtraBold", 'normal');
   		doc.setFontSize(10);
   		doc.text(i18next.t("dateTimePdf"), 10, 60);

   		doc.setFont("Hauora-Regular", 'normal');
   		doc.setFontSize(10);
   		doc.text(dateNow.toLocaleString(), this.props.localesReducer.language === "en" ? 36 : 32, 60);


   		doc.setFont("Hauora-ExtraBold", 'normal');
   		doc.setFontSize(10);
   		doc.text(i18next.t("fileNameWithDS"), 10, 66);

   		doc.setFont("Hauora-Regular", 'normal');
   		doc.setFontSize(10);
   		// doc.text(this.props.defaultState.fileWithDS.name, 55, 66);

   		maxWidth = 120;

		wrappedText = doc.splitTextToSize(this.props.defaultState.fileWithDS.name, maxWidth);
		doc.text(wrappedText, this.props.localesReducer.language === "en" ? 42 : 55, 66);

		if (wrappedText.length > 1) {
			tempOffset = 5;
		}

   		doc.setFont("Hauora-ExtraBold", 'normal');
   		doc.setFontSize(10);
   		doc.text(i18next.t("fileSizeWithDS"), 10, 70 + tempOffset);

   		var res, str = "";
		res = this.props.actions.fromBytes(this.props.defaultState.fileWithDS.size);
		str = res.value + " " + i18next.t(res.unit);

   		doc.setFont("Hauora-Regular", 'normal');
   		doc.setFontSize(10);
   		doc.text(str, this.props.localesReducer.language === "en" ? 38 : 56, 70 + tempOffset);

   		var name = this.props.defaultState.fileWithDS.name.lastIndexOf(".") < 2 ? this.props.defaultState.fileWithDS.name : this.props.defaultState.fileWithDS.name.substr(0, this.props.defaultState.fileWithDS.name.lastIndexOf("."));

   		doc.setFont("Hauora-ExtraBold", 'normal');
   		doc.setFontSize(10);
   		doc.text(i18next.t("fileNameWithoutDS"), 10, 74 + tempOffset);

		function hasSingleExtension(filename) {
		    const parts = filename.split(".");

		    return parts.length === 2;
		}

		function removeExtraExtensions(filename) {
            return filename.replace(/^([^\.]+\.[^\.]+)(\..+)*$/, '$0');
        }

        function removeTrailingP7sExtensions(filename) {
		  return filename.replace(/(?:\.p7s)+$/, '');
		}

		function hasAsicExtension(filename) {
		  const ext = filename.split('.').pop().toLowerCase();
		  return ext === 'asics' || ext === 'asice';
		}

        doc.setFont("Hauora-Regular", 'normal');
   		doc.setFontSize(10);
     	
     	if (this.props.defaultOptionState.signatureType === "detached") {
			dataFileName = this.props.defaultState.fileInput.name
		} else {
			cleaned = removeTrailingP7sExtensions(this.props.defaultState.fileWithDS.name);
			dataFileName = cleaned
		}

		if (hasAsicExtension(this.props.defaultState.fileWithDS.name)) {
			dataFileName = "-"
		}

		if (this.props.defaultOptionState.signatureType !== "detached" && this.props.defaultState.fileSignedData === null) {
			dataFileName = "-"
		}

		maxWidth = 140;

		wrappedText = doc.splitTextToSize(dataFileName, maxWidth);

		if (wrappedText.length > 1) {
			tempOffsetSecond = 5;
		}
		doc.text(wrappedText, this.props.localesReducer.language === "en" ? 45 : 56, 74 + tempOffset);

   		// doc.setFont("Hauora-Regular", 'normal');
   		// doc.setFontSize(10);
   		// doc.text(name, 56, 74);

   		doc.setFont("Hauora-ExtraBold", 'normal');
   		doc.setFontSize(10);
   		doc.text(i18next.t("fileSizeWithoutDS"), 10, 78 + tempOffset + tempOffsetSecond);

   		if (this.props.defaultState.fileSignedData === null) {
   			if (this.props.defaultState.fileInput !== null && this.props.defaultState.fileInput !== undefined) {
   				res = this.props.actions.fromBytes(this.props.defaultState.fileInput.size)
   			} else {
   			 	res = this.props.actions.fromBytes(this.props.defaultState.fileWithDS.size);
   			}
   		} else {
   			res = this.props.actions.fromBytes(this.props.defaultState.fileSignedData.size);
   		}

		str = res.value + " " + i18next.t(res.unit);

		if (hasAsicExtension(this.props.defaultState.fileWithDS.name)) {
			str = "-"
		}

		if (this.props.defaultOptionState.signatureType !== "detached" && this.props.defaultState.fileSignedData === null) {
			str = "-"
		}

		str = res.value + " " + i18next.t(res.unit);

   		doc.setFont("Hauora-Regular", 'normal');
   		doc.setFontSize(10);
   		doc.text(str, this.props.localesReducer.language === "en" ? 43 : 58, 78 + tempOffset + tempOffsetSecond);

   		verticalOffset = verticalOffset + 10
   		doc.setFontSize(10);


   		doc.setFont("Hauora-ExtraBold", 'normal');
   		doc.setFontSize(10);
   		doc.text(i18next.t("verifyResultsTitlePdf"), 10, 85);

   		doc.setFont('Hauora-Regular', 'normal');
   		doc.text(i18next.t("verifySuccessPdf"), this.props.localesReducer.language === "en" ? 61 : 64, 85);
   		// doc.text("Цілісність даних підтверджено.", 10, 69);

   		doc.setFontSize(10);
   		// doc.text(10, 78, str);

   		for (var i = 0; i < this.props.defaultState.verifyResults.length; i += 1) {
			// isValid = this.props.defaultState.verifyResults[i].isValid ? i18next.t("ds:heIsValid") : i18next.t("ds:heIsInvalid")
			// str = i18next.t("ds:signature") + (i + 1) + ": " + isValid + "\n"

			if (this.props.defaultState.verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP") {
   				archTimestampCounter += 1;
   				isValid = this.props.defaultState.verifyResults[i].isValid ? i18next.t("ds:sheIsValid") : i18next.t("ds:sheIsInvalid")
   			} else {
   				isValid = this.props.defaultState.verifyResults[i].isValid ? i18next.t("ds:heIsValid") : i18next.t("ds:heIsInvalid")
   			}

   			if (this.props.defaultState.verifyResults[i].isUntrustedValid) {
				failureCauseSplited = this.props.defaultState.verifyResults[i].failureCause.split('\n')
			}

			if (verticalOffset + 90 > 290) {
				verticalOffset = 10;
				doc.addPage();
				footer()
				doc.setFont('Hauora-Regular', 'normal');

				// var str = this.generateTextResult();
				
				// doc.addImage(img, 'PNG', 10, 10, 65, 17)
				// doc.setFont('Hauora-Regular', 'normal');
				// doc.setFontSize(8);

				// doc.setTextColor("black");

				// doc.setFont('Hauora-ExtraBold', 'bold');
		  //  		doc.text("НЕДП АТ \"Полтава-Банк\"", 90, 15);
		  //  		doc.text("Адреса:", 90, 19);

		  //  		doc.setFont('Hauora-Regular', 'normal');
		  //  		doc.text("36000, Україна, м. Полтава, вул. Пилипа Орлика, 40-а", 102, 19);

		   		// doc.setFont('Hauora-ExtraBold', 'bold');
		   		// doc.text("Тел.:", 90, 23);

		   		// doc.setFont('Hauora-Regular', 'normal');
		   		// doc.text("+38 (044) 484-4612 |", 98, 23);
		   		// doc.text("Факс: +38 (044) 483-0322", 100, 23);

		   		// doc.setFont('Hauora-ExtraBold', 'bold');
		   		// doc.text("E-mail:", 90, 23);

		   		// doc.setFont('Hauora-Regular', 'normal');
		   		// doc.text("nedp@ca.poltavabank.com", 101, 23);

		   		// doc.setFont('Hauora-ExtraBold', 'bold');
		   		// doc.text("Веб-сайт:", 90, 27)
		   		// doc.textWithLink("ca.poltavabank.com", 105, 27, {url: 'ca.poltavabank.com'});
		   		// doc.line(10, 30, 200, 30);

		  //  		doc.setFont('Hauora-Regular', 'normal');
		  //  		doc.setFontSize(18);
		  //  		doc.text("Клієнт Єдиного сервісу криптографічних операцій", 105, 40, {align:'center'});

		  //  		doc.text("ПРОТОКОЛ", 105, 48, {align:'center'});

		  //  		doc.setFontSize(10);
		  //  		doc.setFont('Hauora-Regular', 'normal');
		  //  		doc.text("перевірки кваліфікованого електронного підпису", 105, 53, {align:'center'});

		  //  		doc.setFont("Hauora-ExtraBold", 'normal');
		  //  		doc.setFontSize(10);
		  //  		doc.text("Дата та час: ", 10, 60);

		  //  		doc.setFont("Hauora-Regular", 'normal');
		  //  		doc.setFontSize(10);
		  //  		doc.text(dateNow.toLocaleString(), 32, 60);


		  //  		doc.setFont("Hauora-ExtraBold", 'normal');
		  //  		doc.setFontSize(10);
		  //  		doc.text(i18next.t("fileNameWithDS"), 10, 64);

		  //  		doc.setFont("Hauora-Regular", 'normal');
		  //  		doc.setFontSize(10);
		  //  		doc.text(this.props.defaultState.fileWithDS.name, 55, 64);

		  //  		doc.setFont("Hauora-ExtraBold", 'normal');
		  //  		doc.setFontSize(10);
		  //  		doc.text(i18next.t("fileSizeWithDS"), 10, 68);

				// res = this.props.actions.fromBytes(this.props.defaultState.fileWithDS.size);
				// str = res.value + " " + i18next.t(res.unit);

		  //  		doc.setFont("Hauora-Regular", 'normal');
		  //  		doc.setFontSize(10);
		  //  		doc.text(str, 56, 68);

		  //  		name = this.props.defaultState.fileWithDS.name.lastIndexOf(".") < 2 ? this.props.defaultState.fileWithDS.name : this.props.defaultState.fileWithDS.name.substr(0, this.props.defaultState.fileWithDS.name.lastIndexOf("."));

		  //  		doc.setFont("Hauora-ExtraBold", 'normal');
		  //  		doc.setFontSize(10);
		  //  		doc.text(i18next.t("fileNameWithoutDS"), 10, 72);

		  //  		doc.setFont("Hauora-Regular", 'normal');
		  //  		doc.setFontSize(10);
		  //  		doc.text(name, 56, 72);

		  //  		doc.setFont("Hauora-ExtraBold", 'normal');
		  //  		doc.setFontSize(10);
		  //  		doc.text(i18next.t("fileSizeWithoutDS"), 10, 76);

		  //  		if (this.props.defaultState.fileInput !== null && this.props.defaultState.fileInput !== undefined) {
	   // 				res = this.props.actions.fromBytes(this.props.defaultState.fileInput.size)
	   // 			} else {
	   // 			 	res = this.props.actions.fromBytes(this.props.defaultState.fileWithDS.size);
	   // 			}

				// str = res.value + " " + i18next.t(res.unit);

		  //  		doc.setFont("Hauora-Regular", 'normal');
		  //  		doc.setFontSize(10);
		  //  		doc.text(str, 58, 76);


		  //  		doc.setFont("Hauora-ExtraBold", 'normal');
		  //  		doc.setFontSize(10);
		  //  		doc.text("Результат перевірки підпису: ", 10, 85);

		  //  		doc.setFont('Hauora-Regular', 'normal');
		  //  		doc.text("Підпис перевірено успішно.", 63, 85);
		   		// doc.text("Цілісність даних підтверджено.", 10, 69);

		   		doc.setFontSize(10);
			}

			if (i === 0) {
				verticalOffset = verticalOffset + 24
			} else {
				verticalOffset = verticalOffset + 8
			}
			

			if (this.props.defaultState.verifyResults[i].status === "SUCCESS") {

				if (Object.keys(this.props.defaultState.verifyResults[i].contentTimestamp).length === 0 && this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps.length === 0 && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
					doc.setFont("Hauora-ExtraBold", 'normal');
					doc.setTextColor("red");

					if (this.props.defaultState.verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP") {
		    			doc.text(i18next.t("ds:ARCHIVE_TIMESTAMP") + ": ", 10, verticalOffset)
					} else {
						doc.text(i18next.t("ds:signature") + ((i + 1) - archTimestampCounter) + ": ", 10, verticalOffset);
					}

					if (this.props.defaultState.verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP") {
						doc.text(isValid, this.props.localesReducer.language === "en" ? 55 : 52, verticalOffset);
					} else {
						doc.text(isValid, this.props.localesReducer.language === "en" ? 34 : 27, verticalOffset);
					}

					// doc.text(i18next.t("ds:signature") + (i + 1) + ": ", 10, verticalOffset);
					// doc.text(isValid, 28, verticalOffset);
				} else {

					if (this.props.defaultState.verifyResults[i].isValid) {
						doc.setFont("Hauora-ExtraBold", 'normal');
						doc.setTextColor("green");

						if (this.props.defaultState.verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP") {
			    			doc.text(i18next.t("ds:ARCHIVE_TIMESTAMP") + ": ", 10, verticalOffset)
						} else {
							doc.text(i18next.t("ds:signature") + ((i + 1) - archTimestampCounter) + ": ", 10, verticalOffset);
						}
						// doc.text(i18next.t("ds:signature") + (i + 1) + ": ", 10, verticalOffset);
						// doc.text(isValid, 28, verticalOffset);
						if (this.props.defaultState.verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP") {
							doc.text(isValid, this.props.localesReducer.language === "en" ? 55 : 52, verticalOffset);
						} else {
							doc.text(isValid, this.props.localesReducer.language === "en" ? 34 : 27, verticalOffset);
						}
					} else {
						doc.setFont("Hauora-ExtraBold", 'normal');
						doc.setTextColor("red");

						if (this.props.defaultState.verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP") {
			    			doc.text(i18next.t("ds:ARCHIVE_TIMESTAMP") + ": ", 10, verticalOffset)
						} else {
							doc.text(i18next.t("ds:signature") + ((i + 1) - archTimestampCounter) + ": ", 10, verticalOffset);
						}

						if (this.props.defaultState.verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP") {
							doc.text(isValid, this.props.localesReducer.language === "en" ? 55 : 52, verticalOffset);
						} else {
							doc.text(isValid, this.props.localesReducer.language === "en" ? 34 : 27, verticalOffset);
						}
						// doc.text(i18next.t("ds:signature") + (i + 1) + ": ", 10, verticalOffset);
						// doc.text(isValid, 28, verticalOffset);
					}
					
				}

				verticalOffset = verticalOffset + 5;
				doc.setFont("Hauora-ExtraBold", 'normal');
				doc.setTextColor("black");
				// var isQualified = (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true") ? i18next.t("ds:qualifiedTitle") : i18next.t("ds:unqualifiedTitle")
				// doc.text(isQualified, 10, verticalOffset);
				var isQualified
				if (this.props.defaultState.verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP") {
					isQualified = (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true") ? i18next.t("ds:qualifiedTitleShe") : i18next.t("ds:unqualifiedTitleShe")
				} else {
					isQualified = (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true") ? i18next.t("ds:qualifiedTitle") : i18next.t("ds:unqualifiedTitle")
				}
				doc.text(isQualified, 10, verticalOffset);

				if (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP") {
					verticalOffset = verticalOffset + 5;
					doc.setFont("Hauora-ExtraBold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("ds:signer"), 10, verticalOffset);
					doc.setFont("Hauora-Regular", 'normal');
					doc.text(this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerFullName.value, this.props.localesReducer.language === "en" ? 24 : 33, verticalOffset);
				}

				if (this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
					verticalOffset = verticalOffset + 5;
					doc.setFont("Hauora-ExtraBold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("ds:organizationName"), 10, verticalOffset);
					doc.setFont("Hauora-Regular", 'normal');

					wrappedText = doc.splitTextToSize(this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value, 160);
					doc.text([...wrappedText], this.props.localesReducer.language === "en" ? 35 : 33, verticalOffset);

					if (wrappedText.length > 1) {
						verticalOffset = verticalOffset + 4;
					}

					// doc.text(this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value, 33, verticalOffset);
				}

				if (this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
					verticalOffset = verticalOffset + 5;
					doc.setFont("Hauora-ExtraBold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("ds:title"), 10, verticalOffset);
					doc.setFont("Hauora-Regular", 'normal');

					wrappedText = doc.splitTextToSize(this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value, 160);
					doc.text([...wrappedText], this.props.localesReducer.language === "en" ? 25 : 27, verticalOffset);

					if (wrappedText.length > 1) {
						verticalOffset = verticalOffset + 4;
					}

					// doc.text(this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value, 27, verticalOffset);
				}
				
				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
					verticalOffset = verticalOffset + 5;
					doc.setFont("Hauora-ExtraBold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("ds:drfou"), 10, verticalOffset);
					doc.setFont("Hauora-Regular", 'normal');
					doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value, 27, verticalOffset);
				}
				
				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
					verticalOffset = verticalOffset + 5;
					doc.setFont("Hauora-ExtraBold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("ds:edrpou"), 10, verticalOffset);
					doc.setFont("Hauora-Regular", 'normal');
					doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value, 27, verticalOffset);
				}
		        
		        if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
		        	verticalOffset = verticalOffset + 5;
					doc.setFont("Hauora-ExtraBold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("ds:eddrun"), 10, verticalOffset);
					doc.setFont("Hauora-Regular", 'normal');
					doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value, 27, verticalOffset);
		        }
		       	
		       	if (this.props.defaultState.verifyResults[i].signerInfo.certificateSerialNumber.value) {
		       		verticalOffset = verticalOffset + 5;
					doc.setFont("Hauora-ExtraBold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("certificateSerialNumberTitle"), 10, verticalOffset);
					doc.setFont("Hauora-Regular", 'normal');
					doc.text(this.props.defaultState.verifyResults[i].signerInfo.certificateSerialNumber.value.replace(/\s/g, ""), this.props.localesReducer.language === "en" ? 74 : 85, verticalOffset);
		       	}

		       	if (this.props.defaultState.verifyResults[i].signerInfo.issuerCertificateInfo.value.issuerFullName.value) {
		       		verticalOffset = verticalOffset + 5;
					doc.setFont("Hauora-ExtraBold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("ds:ca"), 10, verticalOffset);
					doc.setFont("Hauora-Regular", 'normal');
					doc.text(this.props.defaultState.verifyResults[i].signerInfo.issuerCertificateInfo.value.issuerFullName.value, this.props.localesReducer.language === "en" ? 20 : 35, verticalOffset);
		       	}

		       	if (this.props.defaultState.verifyResults[i].signingDateTime !== undefined && this.props.defaultState.verifyResults[i].signingDateTime.length > 0 && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
		       		if (Object.keys(this.props.defaultState.verifyResults[i].contentTimestamp).length === 0 && this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps.length === 0) {
			       		verticalOffset = verticalOffset + 5;
						doc.setFont("Hauora-ExtraBold", 'normal');
						doc.setTextColor("red");
						doc.text(i18next.t("ds:dsDate"), 10, verticalOffset);
						doc.setFont("Hauora-Regular", 'normal');
						doc.text(this.formatDate(this.props.defaultState.verifyResults[i].signingDateTime), this.props.localesReducer.language === "en" ? 38 : 35, verticalOffset);

						verticalOffset = verticalOffset + 5;
						doc.setFont("Hauora-ExtraBold", 'normal');
						doc.setTextColor("red");
						if (this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps.length === 0) {
							doc.text(i18next.t("dsTs") + ": ", 10, verticalOffset);
							doc.setFont("Hauora-Regular", 'normal');
							doc.text("Відсутня", 70, verticalOffset);
						}
						
					} else {
						verticalOffset = verticalOffset + 5;
						doc.setFont("Hauora-ExtraBold", 'normal');
						doc.setTextColor("black");
						doc.text(i18next.t("ds:dsDate"), 10, verticalOffset);
						doc.setFont("Hauora-Regular", 'normal');
						doc.text(this.formatDate(this.props.defaultState.verifyResults[i].signingDateTime), this.props.localesReducer.language === "en" ? 38 : 35, verticalOffset);
					}
		       	}

		       	if (Object.keys(this.props.defaultState.verifyResults[i].contentTimestamp).length > 0 && this.props.defaultState.verifyResults[i].contentTimestamp) {
		       		verticalOffset = verticalOffset + 5;

					if (this.props.defaultState.verifyResults[i].contentTimestamp && this.props.defaultState.verifyResults[i].contentTimestamp.dateTime) {
			            if (this.props.defaultState.verifyResults[i].contentTimestamp.isFailure) {
			            	doc.setFont("Hauora-ExtraBold", 'normal');
			            	doc.text(i18next.t("dataTs") + ": ", 10, verticalOffset);
			            	doc.setFont("Hauora-Regular", 'normal');
			            	doc.text(i18next.t("ds:errorWhileVerifying"), 75, verticalOffset);
			            } else {
			            	isValid = this.props.defaultState.verifyResults[i].contentTimestamp.isValid ? i18next.t("ds:sheIsValid") : i18next.t("ds:sheIsInvalid")

			            	doc.setFont("Hauora-ExtraBold", 'normal');
			            	doc.setTextColor("green");
			            	doc.text(i18next.t("dataTs") + ": " + isValid + "; ", 10, verticalOffset);
			            	doc.setFont("Hauora-Regular", 'normal');
			            	doc.text(this.formatDate(this.props.defaultState.verifyResults[i].contentTimestamp.dateTime), this.props.localesReducer.language === "en" ? 60 : 85, verticalOffset);

			            	if (this.props.defaultState.verifyResults[i].contentTimestamp.tsaCertificateSerialNumber) {
			            		verticalOffset = verticalOffset + 5;
			            		doc.setTextColor("black");
			            		doc.setFont("Hauora-ExtraBold", 'normal');
				            	doc.text(i18next.t("tsaCertificateSerialNumber"), 10, verticalOffset);
				            	doc.setFont("Hauora-Regular", 'normal');
				            	doc.text(this.props.defaultState.verifyResults[i].contentTimestamp.tsaCertificateSerialNumber, this.props.localesReducer.language === "en" ? 82 : 125, verticalOffset);
			            	}
			            }
			        }
		       	}

		       	if (this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps.length) {
					for (var j = 0; j < this.props.defaultState.verifyResults[i].signatureTimestamps.length; j += 1) {
						if (this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps[j].dateTime) {
							verticalOffset = verticalOffset + 5;
				            if (this.props.defaultState.verifyResults[i].signatureTimestamps[j].isFailure) {
				            	doc.setFont("Hauora-ExtraBold", 'normal');
				            	doc.text(i18next.t("dataTs") + ": ", 10, verticalOffset);
				            	doc.setFont("Hauora-Regular", 'normal');
				            	doc.text(i18next.t("ds:errorWhileVerifying"), 75, verticalOffset);
				            } else {
				            	isValid = this.props.defaultState.verifyResults[i].signatureTimestamps[j].isValid ? i18next.t("ds:sheIsValid") : i18next.t("ds:sheIsInvalid")

				            	doc.setFont("Hauora-ExtraBold", 'normal');
				            	doc.setTextColor("green");
				            	doc.text(i18next.t("dsTs") + ": " + isValid + "; ", 10, verticalOffset);
				            	doc.setFont("Hauora-Regular", 'normal');
				            	doc.text(this.formatDate(this.props.defaultState.verifyResults[i].signatureTimestamps[j].dateTime), this.props.localesReducer.language === "en" ? 69 : 88, verticalOffset);

				            	if (this.props.defaultState.verifyResults[i].signatureTimestamps[j].tsaCertificateSerialNumber) {
				            		verticalOffset = verticalOffset + 5;
				            		doc.setTextColor("black");
				            		doc.setFont("Hauora-ExtraBold", 'normal');
					            	doc.text(i18next.t("tsaCertificateSerialNumberDS"), 10, verticalOffset);
					            	doc.setFont("Hauora-Regular", 'normal');
					            	doc.text(this.props.defaultState.verifyResults[i].signatureTimestamps[j].tsaCertificateSerialNumber, this.props.localesReducer.language === "en" ? 98 : 119, verticalOffset);
				            	}
				            }
				        }

					}
				}

				if (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP") {
					verticalOffset = verticalOffset + 5;
					doc.setTextColor("black");
	        		doc.setFont("Hauora-ExtraBold", 'normal');
	            	doc.text(i18next.t("ds:isElectronicStampTitle"), 10, verticalOffset);
	            	doc.setFont("Hauora-Regular", 'normal');
	            	doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isElectronicStamp.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase"), this.props.localesReducer.language === "en" ? 41 : 48, verticalOffset);
				}

				if (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP") {
					verticalOffset = verticalOffset + 5;
					doc.setTextColor("black");
	        		doc.setFont("Hauora-ExtraBold", 'normal');
	            	doc.text(i18next.t("ds:qualifiedCertTitle"), 10, verticalOffset);
	            	doc.setFont("Hauora-Regular", 'normal');
	            	doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase"), this.props.localesReducer.language === "en" ? 47 : 61, verticalOffset);
				}

				if (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP") {
	            	verticalOffset = verticalOffset + 5;
					doc.setTextColor("black");
	        		doc.setFont("Hauora-ExtraBold", 'normal');
	            	doc.text(i18next.t("ds:QSCDTitle"), 10, verticalOffset);
	            	doc.setFont("Hauora-Regular", 'normal');
	            	doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase"), this.props.localesReducer.language === "en" ? 23 : 29, verticalOffset);
				}

				if (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP") {
	            	verticalOffset = verticalOffset + 5;
					doc.setTextColor("black");
	        		doc.setFont("Hauora-ExtraBold", 'normal');
	            	doc.text(i18next.t("ds:QSCDTypeTitle"), 10, verticalOffset);
	            	doc.setFont("Hauora-Regular", 'normal');
	            	doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value === null ? i18next.t("ds:notDefined") : this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value, this.props.localesReducer.language === "en" ? 31 : 39, verticalOffset);
				}

            	if (this.props.defaultState.verifyResults[i].signatureType && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
            		verticalOffset = verticalOffset + 5;
					doc.setTextColor("black");
	        		doc.setFont("Hauora-ExtraBold", 'normal');
	            	doc.text(i18next.t("ds:signatureType"), 10, verticalOffset);
	            	doc.setFont("Hauora-Regular", 'normal');
	            	doc.text(this.props.defaultState.verifyResults[i].signatureType === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + this.props.defaultState.verifyResults[i].signatureType), this.props.localesReducer.language === "en" ? 38 : 41, verticalOffset);
            	}

            	if (this.props.defaultState.verifyResults[i].signatureFormat) {
            		verticalOffset = verticalOffset + 5;
					doc.setTextColor("black");
	        		doc.setFont("Hauora-ExtraBold", 'normal');
	            	doc.text(i18next.t("ds:signatureFormat"), 10, verticalOffset);
	            	doc.setFont("Hauora-Regular", 'normal');

					if (this.props.defaultState.verifyResults[i].signatureFormat !== null && this.props.defaultState.verifyResults[i].signatureFormat === "CADES_T" && this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "false")
					{
                		doc.text(i18next.t("ds:CADES_TU"), this.props.localesReducer.language === "en" ? 42 : 40, verticalOffset);
                	} else {
                		doc.text(this.props.defaultState.verifyResults[i].signatureFormat === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + this.props.defaultState.verifyResults[i].signatureFormat), this.props.localesReducer.language === "en" ? 42 : 40, verticalOffset);
                	}
	            	
            	}

				if (Object.keys(this.props.defaultState.verifyResults[i].contentTimestamp).length === 0 && this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps.length === 0 && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
					verticalOffset = verticalOffset + 10;
            		doc.setTextColor("red");
            		doc.setFont("Hauora-ExtraBold", 'normal');
	            	doc.text(i18next.t("ds:lawMsgFirstRow"), 10, verticalOffset);

	            	verticalOffset = verticalOffset + 10;
            		doc.setTextColor("red");
            		doc.setFont("Hauora-Regular", 'normal');
	            	doc.text(i18next.t("ds:lawMsgSecondRowPDF"), 10, verticalOffset);

	            	verticalOffset = verticalOffset + 5;
            		doc.setTextColor("red");
            		doc.setFont("Hauora-Regular", 'normal');
	            	doc.text(i18next.t("ds:lawMsgThirdRowPDF"), 10, verticalOffset);

	            	verticalOffset = verticalOffset + 5;
            		doc.setTextColor("red");
            		doc.setFont("Hauora-Regular", 'normal');
	            	doc.text(i18next.t("ds:lawMsgFourthRowPDF"), 10, verticalOffset);

	            	verticalOffset = verticalOffset + 10;
            		doc.setTextColor("red");
            		doc.setFont("Hauora-Regular", 'normal');
	            	doc.text(i18next.t("ds:lawMsgFifthRowPDF"), 10, verticalOffset);

	            	verticalOffset = verticalOffset + 5;
            		doc.setTextColor("red");
            		doc.setFont("Hauora-Regular", 'normal');
	            	doc.text(i18next.t("ds:lawMsgSixthRowPDF"), 10, verticalOffset);
				}

			} else {
				doc.setFont("Hauora-ExtraBold", 'normal');
				doc.setTextColor("red");
				doc.text(i18next.t("ds:signature") + (i + 1) + ": ", 10, verticalOffset);
				doc.text(i18next.t("ds:notDefined"), 28, verticalOffset);

				var splitText = doc.splitTextToSize(this.props.defaultState.verifyResults[i].failureCause, 180);
				doc.setFont("Hauora-Regular", 'normal');
				doc.setTextColor("black");

				verticalOffset = verticalOffset + 5;

				for (var c = 0; c < splitText.length; c += 1){
			        doc.text(10, verticalOffset, splitText[c]);
			        verticalOffset = verticalOffset + 5;
			    }
			}
		}

		verticalOffset = verticalOffset + 10;
		doc.setFont("Hauora-Regular", 'normal');
		doc.setTextColor("black");
		doc.text(i18next.t("verifyAddressPdf"), 10, verticalOffset);
		doc.setTextColor("blue");
		doc.textWithLink("caas.poltavabank.com", 10, verticalOffset + 5, {url: 'https://caas.poltavabank.com/'});

   		// doc.output("dataurlnewwindow");
   		var fileName
   		if (this.props.defaultState.fileInputName.length > 0) {
   			fileName = this.props.defaultState.fileInputName.substring(0, this.props.defaultState.fileInputName.indexOf('.')) || this.props.defaultState.fileInputName;
			doc.save(fileName + "-validation-report.pdf")
		} else {
			fileName = this.props.defaultState.fileWithDSName.substring(0, this.props.defaultState.fileWithDSName.indexOf('.')) || this.props.defaultState.fileWithDSName;
			doc.save(fileName + "-validation-report.pdf")
		}
	}

	formatDate(dateInString) {
        var localeDateOptions = {
            "day": "numeric",
            "month": "numeric",
            "year": "numeric",
            "hour": "2-digit",
            "minute": "2-digit",
            "second": "2-digit",
            "timeZoneName": "short"
        }

        return new Date(dateInString).toLocaleDateString(i18next.language, localeDateOptions);
    }

    constructTimestampDetails(aTs, aTsType) {
        let contentTs = i18next.t("dataTs");
        let signatureTs = i18next.t("dsTs");
        let tsaDS = i18next.t("tsaCertificateSerialNumberDS");
        let tsa = i18next.t("tsaCertificateSerialNumber");
        let result = [];

        let tsTypeString = function () {
            if (aTsType === "content") {
                return contentTs;
            }
            if (aTsType === "signature") {
                return signatureTs;
            }
            return "";
        }

        let tsaTsTypeString = function () {
            if (aTsType === "content") {
                return tsa;
            }
            if (aTsType === "signature") {
                return tsaDS;
            }
            return "";
        }
        
        if (aTs && aTs.dateTime) {
            if (aTs.isFailure) {
                result.push(<div>{tsTypeString() + i18next.t("ds:errorWhileVerifying")}</div>);
            } else {
            	result.push(
	            	<div>
	            		<div>
	            			<span className="font-weight-bold">{tsTypeString()}</span>
	            			{
			            		": "
			                    + (aTs.isValid ? i18next.t("ds:sheIsValid") : i18next.t("ds:sheIsInvalid"))
			                    + "; "
			                    + this.formatDate(aTs.dateTime)
		                	}
		                	{
		                		aTs.tsaCertificateSerialNumber
		                		? <div><span className="font-weight-bold">{tsaTsTypeString()}</span>
				                	{
					                    aTs.tsaCertificateSerialNumber
				                	}
				                </div>
				                : null
		                	}	                	
	            		</div>
	                </div>
                );
            }
        }
        return result;
    }

    constructTimestampDetailsText(aTs, aTsType) {
        let contentTs = i18next.t("dataTs");
        let signatureTs = i18next.t("dsTs");
        let tsaDS = i18next.t("tsaCertificateSerialNumberDS");
        let tsa = i18next.t("tsaCertificateSerialNumber");
        let result = [];

        let tsTypeString = function () {
            if (aTsType === "content") {
                return contentTs;
            }
            if (aTsType === "signature") {
                return signatureTs;
            }
            return "";
        }

        let tsaTsTypeString = function () {
            if (aTsType === "content") {
                return tsa;
            }
            if (aTsType === "signature") {
                return tsaDS;
            }
            return "";
        }
        
        if (aTs && aTs.dateTime) {
            if (aTs.isFailure) {
                result = tsTypeString() + ": " + i18next.t("ds:errorWhileVerifying") + "\n";
            } else {
            	var isValid = aTs.isValid ? i18next.t("ds:sheIsValid") : i18next.t("ds:sheIsInvalid")
            	result = tsTypeString() + ": " + isValid + "; " + this.formatDate(aTs.dateTime) + "\n"

            	if (aTs.tsaCertificateSerialNumber) {
            		result += tsaTsTypeString() + aTs.tsaCertificateSerialNumber + "\n"
            	}
            }
        }
        return result;
    }

	showDsVerifyResults(verifyResults, elementToDisplay, resultType) {
		let rootDiv = [], divPtblg = [], diffType = [], _this = this, archTimestampCounter = 0, failureCauseSplited;
		var generateVerifyResultsViewSimple = generateVerifyResultsViewSimple.bind(this);

		const safeDateParse = (inputData, invalidDate) =>
	    Date.parse(inputData) || invalidDate;

		const highestPriorityDate = (inputObject) =>
		    [
		        inputObject.signatureTimestamps.reduce(
		            (a, b) =>
		                Math.min(
		                    safeDateParse(a.dateTime, Number.MAX_SAFE_INTEGER),
		                    safeDateParse(b.dateTime, Number.MAX_SAFE_INTEGER)
		                ),
		            Number.MAX_SAFE_INTEGER
		        ),
		        safeDateParse(
		            inputObject.contentTimestamp.dateTime,
		            Number.MAX_SAFE_INTEGER
		        ),
		        Date.parse(inputObject.signingDateTime),
		    ].filter((a) => a !== Number.MAX_SAFE_INTEGER)[0];

	    verifyResults
        .sort((first, second) => {
            const firstHash = highestPriorityDate(first);
            const secondHash = highestPriorityDate(second);

            if (firstHash < secondHash) {
                return -1;
            }

            if (firstHash > secondHash) {
                return 1;
            }

            return 0;
        })
        .map(highestPriorityDate)

        if (this.props.defaultOptionState.showUpgradeCard) {
        	verifyResults.forEach(function (element) {
	        	_this.props.defaultState.differenceSignatureType.forEach(function (secondElement) {
	        		if (element.signerInfo.certificateSerialNumber !== undefined) {
	        			if (element.signerInfo.certificateSerialNumber.value === secondElement.signerInfo.certificateSerialNumber.value) {
		        			diffType.push(secondElement)
		        		}
	        		}
	        	})
	        })
        }

        function generateVerifyResultsViewSimple (verifyResults) {
        	for (var i = 0; i < verifyResults.length; i += 1) {
	        	let signerNumber = [];
				let signerStatus = [];
				let signerDetails = [];
				let tsDetails = [];
				let tempString = [];

				if (verifyResults[i].isUntrustedValid) {
					failureCauseSplited = verifyResults[i].failureCause.split('\n')
				}

				if (verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP") {
					archTimestampCounter += 1;
				}

				if (verifyResults[i].signatureTimestamps && verifyResults[i].signatureTimestamps.length) {
					for (var j = 0; j < verifyResults[i].signatureTimestamps.length; j += 1) {
						tsDetails.push(_this.constructTimestampDetails(verifyResults[i].signatureTimestamps[j], "signature"))
					}
				} else {
					if (!this.props.defaultOptionState.showUpgradeCard && (Object.keys(verifyResults[i].contentTimestamp).length === 0) && (verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
						tempString.push(<div style={{fontSize: "14px", color: "red"}}>
							<hr style={{marginBottom: "0px", marginTop: "5px"}} />
							<span><p>{i18next.t("ds:lawMsgFirstRow")}</p></span>
							<span><p>{i18next.t("ds:lawMsgSecondRow")}</p></span>
							<span><p>{i18next.t("ds:lawMsgThirdRow")}</p></span>
						</div>);
					}			
				}

				

	        	signerNumber.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
		        	{	
		        		verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP"
		    			? i18next.t("ds:ARCHIVE_TIMESTAMP")
		    			: i18next.t("ds:signature") + ((i + 1) - archTimestampCounter)
		        	}
	        	</div>)

	        	if (verifyResults[i].status === "SUCCESS") {
	        		if (resultType === "verifyResults") {
	        			signerStatus.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{paddingRight: "5px"}}>
		        			{
		        				verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP"
		        				? verifyResults[i].isValid ? i18next.t("ds:sheIsValidUpper") : i18next.t("ds:sheIsInvalidUpper")
		        				: verifyResults[i].isValid ? i18next.t("ds:heIsValid") : i18next.t("ds:heIsInvalid")
		        			}
		        			<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
			        			{
			        				(verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true")
			        				? (verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP" ? i18next.t("ds:qualifiedTitleShe") : i18next.t("ds:qualifiedTitle"))
			        				: (verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP" ? i18next.t("ds:unqualifiedTitleShe") : i18next.t("ds:unqualifiedTitle"))
			        			}
			        		</div>
			        		{
			        			verifyResults[i].failureCause !== null && verifyResults[i].failureCause !== undefined && verifyResults[i].failureCause.length > 0
			        			? <span style={{color: "red"}}>{verifyResults[i].failureCause}</span>
			        			: null
			        		}
		        		</div>)
	        		} else {
	        			signerStatus.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding" style={{paddingRight: "5px"}}>
		        			{
		        				verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP"
		        				? verifyResults[i].isValid ? i18next.t("ds:sheIsValidUpper") : i18next.t("ds:sheIsInvalidUpper")
		        				: verifyResults[i].isValid ? i18next.t("ds:heIsValid") : i18next.t("ds:heIsInvalid")
		        			}
		        			<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
			        			{
			        				(verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true")
			        				? (verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP" ? i18next.t("ds:qualifiedTitleShe") : i18next.t("ds:qualifiedTitle"))
			        				: (verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP" ? i18next.t("ds:unqualifiedTitleShe") : i18next.t("ds:unqualifiedTitle"))
			        			}
			        		</div>
			        		
		        		</div>)
	        		}
			        
			        signerDetails.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 signer-details no-left-right-padding">
		    			<div>
		    				{
		    					verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP"
		    					? <div><span className="font-weight-bold">{ i18next.t("ds:signer")}</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerFullName.value }</span></div>
		    					: null
		    				}
		    			</div>
		    				{
								verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:organizationName") }</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value }</span>
					        		</div> : null
					        } {

								verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:title") }</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value }</span>
					        		</div> : null
					        } {
								verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:drfou") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value }</span>
					        		</div> : null
					        } {
					        	verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value ? 
						        	<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:edrpou")}</span><span>{ verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value }</span>
					        		</div> : null
					        } {
					        	verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value ? 
					        		<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:eddrun")}</span><span>{ verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value }</span>
					        		</div> : null
					        }
		    			<div>
		    				<span className="font-weight-bold">{ i18next.t("ds:ca")}</span><span>{verifyResults[i].signerInfo.issuerCertificateInfo.value.issuerFullName.value }</span>
		        		</div>
		        		 	{
					        	verifyResults[i].signerInfo.certificateSerialNumber.value ? 
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("certificateSerialNumberTitle")}</span><span>{verifyResults[i].signerInfo.certificateSerialNumber.value.replace(/\s/g, "") }</span>
					        		</div> : null
		                    }
		    			<div>
		    				{
		    					verifyResults[i].signingDateTime !== undefined && verifyResults[i].signingDateTime.length > 0
		    					? <span><span className="font-weight-bold">{ i18next.t("ds:dsDate")}</span><span>{_this.formatDate(verifyResults[i].signingDateTime)}</span></span>
		    					: null
		    				}
		    			</div>
		    			<div>
		    				{
		    					_this.constructTimestampDetails(verifyResults[i].contentTimestamp, "content")
		    				}
		    			</div>
		    			<div>
		    				{
		    					tsDetails
			                }
		    			</div>
		    			<div>
		    				{
								verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.isElectronicStamp ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:isElectronicStampTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.isElectronicStamp.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
					        		</div> : null
					        }
		    				{
								verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:qualifiedCertTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
					        		</div> : null
					        }
					        {
								verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:QSCDTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
					        		</div> : null
					        }
					        {
								verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:QSCDTypeTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value === null ? i18next.t("ds:notDefined") : verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value}</span>
					        		</div> : null
					        }
					        {
								verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:signatureType") }</span> <span>{verifyResults[i].signatureType === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + verifyResults[i].signatureType)}</span>
					        		</div> : null
					        }
					        {
								verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureFormat ?
			                        <div>
			                        	{
			                        		verifyResults[i].signatureFormat !== null && verifyResults[i].signatureFormat === "CADES_T" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "false"
			                        		?  <div><span className="font-weight-bold">{ i18next.t("ds:signatureFormat") }</span> <span>{i18next.t("ds:CADES_TU")}</span></div>
			                        		: <div><span className="font-weight-bold">{ i18next.t("ds:signatureFormat") }</span> <span>{verifyResults[i].signatureFormat === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + verifyResults[i].signatureFormat)}</span></div>
			                        	}
					    				
					        		</div> : null
					        }
					        {
			        			verifyResults[i].failureCause !== null && verifyResults[i].failureCause !== undefined && verifyResults[i].failureCause.length > 0
			        			? <div style={{marginTop: "10px"}}><span className="font-weight-bold">{verifyResults[i].failureCause}</span></div>
			        			: null
			        		}
		    			</div>
		    		</div>)

		        	divPtblg.push(<div className="ptblg-default" id={"depth"} style={{marginLeft: "-10px", marginRight: "-10px", marginTop: "-10px"}}>
		        		{	
		        			_this.props.defaultOptionState.showUpgradeCard && (diffType[i].previousSignatureFormat === "CADES_X_LONG" ? true : false)
				    		? <div className="alert alert-warning">
				        		{i18next.t("ds:alreadyModifiedTitle")}
				        	</div>
				        	: null
		        		}
		        		{
							 <div className={(verifyResults[i].isValid && tempString.length === 0) ? "alert alert-success" : "alert alert-warning"}>
				        		<div className="row">
				        			<div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 no-left-right-padding" style={{paddingLeft: "11px"}}>{signerNumber} {signerStatus}{(verifyResults[i].signatureImageData !== null && verifyResults[i].signatureImageData !== undefined && verifyResults[i].signatureImageData.length > 0) ? <div style={{paddingRight: "15px"}}><label className="col-12" style={{paddingLeft: "0px", paddingRight: "0px"}}>{i18next.t("hwsImageLabel")}</label><img style={{maxWidth: "100%", maxHeight: "100%", cursor: "pointer"}} src={"data:image/png;base64," + verifyResults[i].signatureImageData} onClick={_this.handleShowPrivateSign.bind(_this, verifyResults[i].signatureImageData)} alt="" /></div> : null}{_this.props.defaultOptionState.generateQR ? <div><label className="col-12" style={{paddingLeft: "0px", paddingRight: "0px", paddingTop: "10px"}}>{i18next.t("QRSignLabel")}</label><img src={_this.props.defaultState.verifyResultsForQR[i]} onClick={_this.handleShowQR.bind(_this, i)} style={{width: "100px", height: "100px", cursor: "pointer"}} alt="" /></div> : null}</div><div className="col-lg-8 col-md-8 col-sm-12 col-xs-12 no-left-no-right-padding">{signerDetails}</div>
				        		</div>
				        		<div>
					        		{
					        			tempString
					        		}
					        	</div>
				        	</div>
				        }
		        	</div>)
		        } else {
		        	if (verifyResults[i].isUntrustedValid) {
		        		signerStatus.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
		        			{i18next.t("ds:notDefined")}
			        	</div>)
		        		signerDetails.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 signer-details no-left-right-padding">
			    			<div>
			    				<span className="font-weight-bold">{ i18next.t("ds:signer")}</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerFullName.value }</span>
			    			</div>
			    				{
									verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:organizationName") }</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value }</span>
						        		</div> : null
						        } {
									verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:title") }</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value }</span>
						        		</div> : null
						        } {
									verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:drfou") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value }</span>
						        		</div> : null
						        } {
						        	verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value ? 
							        	<div>
						    				<span className="font-weight-bold">{ i18next.t("ds:edrpou")}</span><span>{ verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value }</span>
						        		</div> : null
						        } {
						        	verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value ? 
						        		<div>
						    				<span className="font-weight-bold">{ i18next.t("ds:eddrun")}</span><span>{ verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value }</span>
						        		</div> : null
						        }
			    			<div>
			    				<span className="font-weight-bold">{ i18next.t("ds:ca")}</span><span>{verifyResults[i].signerInfo.issuerCertificateInfo.value.issuerFullName.value }</span>
			        		</div>
			        		 	{
						        	verifyResults[i].signerInfo.certificateSerialNumber.value ? 
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("certificateSerialNumberTitle")}</span><span>{verifyResults[i].signerInfo.certificateSerialNumber.value.replace(/\s/g, "") }</span>
						        		</div> : null
			                    }
			    			<div>
			    				{
			    					verifyResults[i].signingDateTime !== undefined && verifyResults[i].signingDateTime.length > 0
			    					? <span><span className="font-weight-bold">{ i18next.t("ds:dsDate")}</span><span>{_this.formatDate(verifyResults[i].signingDateTime)}</span></span>
			    					: null
			    				}
			    			</div>
			    			<div>
			    				{
			    					_this.constructTimestampDetails(verifyResults[i].contentTimestamp, "content")
			    				}
			    			</div>
			    			<div>
			    				{
			    					tsDetails
				                }
			    			</div>
			    			<div>
			    				{
									verifyResults[i].signerInfo.extensionsCertificateInfo.value.isElectronicStamp ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:isElectronicStampTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.isElectronicStamp.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
						        		</div> : null
						        }
			    				{
									verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:qualifiedCertTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
						        		</div> : null
						        }
						        {
									verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:QSCDTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
						        		</div> : null
						        }
						        {
									verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:QSCDTypeTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value === null ? i18next.t("ds:notDefined") : verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value}</span>
						        		</div> : null
						        }
						        {
									verifyResults[i].signatureType ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:signatureType") }</span> <span>{verifyResults[i].signatureType === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + verifyResults[i].signatureType)}</span>
						        		</div> : null
						        }
						        {
									verifyResults[i].signatureFormat ?
				                        <div>
				                        	{
				                        		verifyResults[i].signatureFormat !== null && verifyResults[i].signatureFormat === "CADES_T" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "false"
				                        		?  <div><span className="font-weight-bold">{ i18next.t("ds:signatureFormat") }</span> <span>{i18next.t("ds:CADES_TU")}</span></div>
				                        		: <div><span className="font-weight-bold">{ i18next.t("ds:signatureFormat") }</span> <span>{verifyResults[i].signatureFormat === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + verifyResults[i].signatureFormat)}</span></div>
				                        	}
						    				
						        		</div> : null
						        }
						        {
						            verifyResults[i].isUntrustedValid
						            ? <div><p></p>
						            	<div>
						            		{
						            			<p><b>{failureCauseSplited[0]}</b></p>
						            		}
						            		
						            		{/*<p style={{"marginBottom": "0.5rem"}}><b>{i18next.t("ds:signatureValidWithUntrustedTime")}</b></p>*/}
						            	</div>
						            </div>
						            : null
						        }
			    			</div>
			    		</div>)
						divPtblg.push(<div className="ptblg-default" id={"depth"} style={{marginLeft: "-10px", marginRight: "-10px", marginTop: "-10px"}}>
			        		<div className={(verifyResults[i].isValid && tempString.length === 0) ? "alert alert-success" : "alert alert-warning"}>
				        		<div className="row">
				        			<div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 no-left-no-right-padding" style={{paddingLeft: "11px"}}>{signerNumber} {signerStatus}</div> <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12 no-left-no-right-padding">{signerDetails}</div>
				        		</div>
				        	</div>
			        	</div>)
		        	} else {
		        		signerStatus.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
		        			{i18next.t("ds:notDefined")}
			        		</div>)
				        signerDetails.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 signer-details no-left-right-padding">
				    			<div>
				    				{ verifyResults[i].failureCause }
				    				{/*{
							            verifyResults[i].isUntrustedValid
							            ? <div><p></p><div><b>{i18next.t("ds:signatureValidWithUntrustedTime")}</b></div></div>
							            : null
							        }*/}
				    			</div>
			    			</div>)
			        	divPtblg.push(<div className="ptblg-default" id={"depth"} style={{marginLeft: "-10px", marginRight: "-10px", marginTop: "-10px"}}>
			        		<div className={(verifyResults[i].isValid && tempString.length === 0) ? "alert alert-success" : "alert alert-warning"}>
				        		<div className="row">
				        			<div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 no-left-no-right-padding">{signerNumber} {signerStatus}</div> <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12 no-left-no-right-padding">{signerDetails}</div>
				        		</div>
				        	</div>
			        	</div>)
		        	}
			        
	            }
	        }
        }

        function generateModifyResults (verifyResults) {
			for (var i = 0; i < verifyResults.length; i += 1) {
				let signerNumber = [];
				let signerStatus = [];
				let signerDetails = [];		

	        	signerNumber.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
	    			{i18next.t("ds:signature") + (i + 1)}
	        	</div>)
	        		
    			signerStatus.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding" style={{paddingRight: "5px"}}>
        			{
        				verifyResults[i].previousSignatureFormat === verifyResults[i].currentSignatureFormat ? i18next.t("ds:isNotModified") : i18next.t("ds:isModified")
        			}
        		</div>)
		        
		        signerDetails.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 signer-details no-left-right-padding">
	    			<div>
	    				<span className="font-weight-bold">{ i18next.t("ds:signer")}</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerFullName.value }</span>
	    			</div>
	    				{
							verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value ?
		                        <div>
				    				<span className="font-weight-bold">{ i18next.t("ds:organizationName") }</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value }</span>
				        		</div> : null
				        } {
							verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value ?
		                        <div>
				    				<span className="font-weight-bold">{ i18next.t("ds:title") }</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value }</span>
				        		</div> : null
				        } {
							verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value ?
		                        <div>
				    				<span className="font-weight-bold">{ i18next.t("ds:drfou") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value }</span>
				        		</div> : null
				        } {
				        	verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value ? 
					        	<div>
				    				<span className="font-weight-bold">{ i18next.t("ds:edrpou")}</span><span>{ verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value }</span>
				        		</div> : null
				        } {
				        	verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value ? 
				        		<div>
				    				<span className="font-weight-bold">{ i18next.t("ds:eddrun")}</span><span>{ verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value }</span>
				        		</div> : null
				        }
	    			<div>
	    				<span className="font-weight-bold">{ i18next.t("ds:ca")}</span><span>{verifyResults[i].signerInfo.issuerCertificateInfo.value.issuerFullName.value }</span>
	        		</div>

	        		{
	        			verifyResults[i].previousSignatureFormat === verifyResults[i].currentSignatureFormat
	        			? <div>
							{
					        	verifyResults[i].currentSignatureType ?
					        		<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:signatureType")}</span><span>{ i18next.t("ds:" + verifyResults[i].currentSignatureType) }</span>
					        		</div> : null
					        }
					        {
					        	verifyResults[i].currentSignatureFormat ?
					        		<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:signatureFormat")}</span><span>{ i18next.t("ds:" + verifyResults[i].currentSignatureFormat) }</span>
					        		</div> : null
					        }
	        			</div>
	        			: <div>
		        			{
					        	verifyResults[i].previousSignatureFormat ?
					        		<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:previousSignatureFormat")}</span><span>{ i18next.t("ds:" + verifyResults[i].previousSignatureFormat) }</span>
					        		</div> : null
					        }
					        {
					        	verifyResults[i].currentSignatureFormat ?
					        		<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:currentSignatureFormat")}</span><span>{ i18next.t("ds:" + verifyResults[i].currentSignatureFormat) }</span>
					        		</div> : null
					        }

					        {
					        	verifyResults[i].previousSignatureType ?
					        		<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:previousSignatureType")}</span><span>{ i18next.t("ds:" + verifyResults[i].previousSignatureType) }</span>
					        		</div> : null
					        }
					        {
					        	verifyResults[i].currentSignatureType ?
					        		<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:currentSignatureType")}</span><span>{ i18next.t("ds:" + verifyResults[i].currentSignatureType) }</span>
					        		</div> : null
					        }
					    </div>
	        		}
	        		{
	        			verifyResults[i].failureCause !== null && verifyResults[i].failureCause !== undefined && verifyResults[i].failureCause.length > 0
	        			? <div style={{paddingTop: "10px"}}><span className="font-weight-bold">{verifyResults[i].failureCause}</span></div>
	        			: null
	        		}
	        		
	    		</div>)

	        	divPtblg.push(<div className="ptblg-default" style={{marginLeft: "-10px", marginRight: "-10px", marginTop: "-10px"}}>
	        		{
						 <div className={(verifyResults[i].status === "SUCCESS") ? "alert alert-success" : "alert alert-warning"}>
			        		<div className="row">
			        			<div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 no-left-right-padding" style={{paddingLeft: "11px"}}>{signerNumber} {signerStatus}</div> <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12 no-left-no-right-padding">{signerDetails}</div>
			        		</div>
			        	</div>
			        }
	        	</div>)
			}
		}

        if (!this.props.defaultOptionState.showUpgradeCard) {
        	generateVerifyResultsViewSimple(verifyResults)
        	rootDiv.push(<div id="divPtblg">{divPtblg}</div>)
		} else {
			generateModifyResults(_this.props.defaultState.differenceSignatureType)
	        rootDiv.push(<div id="divPtblg">{divPtblg}</div>)
		}
          
        return rootDiv
    }

    showPreviewPopupVerify () {
		this.props.actions.setShowPreviewPopupVerify(true);
	}

	render () {
		const isEnabled = this.props.defaultOptionState.signatureType === 'detached' ?
				this.props.defaultState.fileInputSelected && this.props.defaultState.fileWithDSSelected
				: this.props.defaultState.fileWithDSSelected;

		const isEnabledDownload = this.props.defaultState.fileSignedData ? true : false;

		const isPreviewEnabled = this.props.defaultState.fileSignedData && this.props.defaultState.fileWithDSName ? true : false

		const isEnabledDownloadModifiedDS = this.props.upgradeReducer.modifiedDSData ? true : false;

		return (
			<div>
	            <div className="row" style={{paddingTop: "10px"}}>
	            <VerifyDSOptionsContainer />
	              <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
	                <div className="card">
	                  <div className="card-header" onClick={this.expandVerifyDS.bind(this)} role="button">
	                    {
							this.props.expandedCardsReducer.verifyExpanded ? <i className="fa fa-chevron-down" aria-hidden="true" style={{"cursor": "pointer"}}></i>
								: <i className="fa fa-chevron-up" aria-hidden="true" style={{"cursor": "pointer"}}></i>
						}&nbsp;{i18next.t("file")}
	                  </div>
	                  <div className={this.state.collapseVerifyDSShow} data-toggle="collapse" aria-expanded={this.props.expandedCardsReducer.verifyExpanded}>
	                    <div>
	                    	{
	                    		this.props.defaultOptionState.signatureType === 'detached'
	                    		? <div className="no-left-right-padding">
	                    			<label className="col-lg-12 col-md-12 col-xs-12 col-sm-12 col-form-label no-left-right-padding">{i18next.t("ds:fileForVerifyingTitle")}</label>
	                                <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 no-left-right-padding">
		                                {
		                                  this.props.mobileModeReducer.mobileDeviceMode
		                                  ? 
		                                  <div className="input-group row" style={{marginLeft: "0px"}}>
		                                    <input type="text" className="form-control col-lg-8 col-md-8 col-xs-12 col-sm-12"  value={this.props.defaultState.fileInputName} style={{"backgroundColor": "white", "cursor": "pointer"}} onClick={this.handleFileInputSelect.bind(this)} readOnly />
		                                    {
												this.props.defaultState.fileInputSelected
												? <button className="btn btn-default col-lg-4 col-md-4 col-xs-12 col-sm-12 margin-top-sm" style={{"cursor": "pointer"}} onClick={this.handleFileInputSelect.bind(this)}>{i18next.t("changeFile")}</button>
												: <button className="btn btn-default col-lg-4 col-md-4 col-xs-12 col-sm-12 margin-top-sm" style={{"cursor": "pointer"}} onClick={this.handleFileInputSelect.bind(this)}>{i18next.t("chooseFile")}</button>
											}

		                                  </div>
		                                  : <div>
		                                  		{
		                                  			this.props.defaultState.fileInputSelected
		                                  			? <div className="input-group mb-4">
														<input type="text" className="form-control" value={this.props.defaultState.fileInputName} style={{"backgroundColor": "white", "cursor": "pointer"}} onClick={this.handleFileInputSelect.bind(this)} readOnly />
														<div className="input-group-append">
													      	<button className="input-group-text" style={{"cursor": "pointer"}} onClick={this.cleanUpFileInputSelect.bind(this)}>{i18next.t("cleanup")}</button>
													    </div>
													</div>
								                    : <Dropzone ref={dropzoneRef} onDrop={this.handleOnDrop} multiple={false}>
								                        {({getRootProps, getInputProps}) => (
								                            <div {...getRootProps()} style={{cursor: "pointer"}} className="dropzone" id="dropFile">
								                                <input {...getInputProps()} />
								                                <p style={{cursor: "pointer", marginTop: "16px"}}>{i18next.t("dragNDropTitleSecond")}</p>
								                            </div>
								                        )}
								                    </Dropzone>
		                                  		}
											</div>
		                                }
	                                </div>
	                                <input id="fileInputUpload" type="file" onChange={this.onChangeInput.bind(this)} style={{"display": "none"}} />
	                            </div>
								: <input id="fileInputUpload" type="file" onChange={this.onChangeInput.bind(this)} style={{"display": "none"}} />
	                    	}

	                    	<div className="no-left-right-padding" style={{marginBottom: "10px"}}>
                    			<label className="col-lg-12 col-md-12 col-xs-12 col-sm-12 col-form-label no-left-right-padding">{i18next.t("ds:fileWithDsTitle")}</label>
                                <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 no-left-right-padding">
	                                {
	                                  this.props.mobileModeReducer.mobileDeviceMode
	                                  ? 
	                                  <div className="input-group row" style={{marginLeft: "0px"}}>
	                                    <input type="text" className="form-control col-lg-8 col-md-8 col-xs-12 col-sm-12"  value={this.props.defaultState.fileWithDSName} style={{"backgroundColor": "white", "cursor": "pointer"}} onClick={this.handleFileWithDSSelect.bind(this)} readOnly />
	                                    {
											this.props.defaultState.fileWithDSSelected
											? <button className="btn btn-default col-lg-4 col-md-4 col-xs-12 col-sm-12 margin-top-sm" style={{"cursor": "pointer"}} onClick={this.handleFileWithDSSelect.bind(this)}>{i18next.t("changeFile")}</button>
											: <button className="btn btn-default col-lg-4 col-md-4 col-xs-12 col-sm-12 margin-top-sm" style={{"cursor": "pointer"}} onClick={this.handleFileWithDSSelect.bind(this)}>{i18next.t("chooseFile")}</button>
										}
	                                    </div>
	                                    : <div>
	                                    	{
	                                    		this.props.defaultState.fileWithDSSelected
	                                    		? <div className="input-group mb-4">
													<input type="text" className="form-control" value={this.props.defaultState.fileWithDSName} style={{"backgroundColor": "white", "cursor": "pointer"}} onClick={this.handleFileWithDSSelect.bind(this)} readOnly />
													<div className="input-group-append">
												      	<button className="input-group-text" style={{"cursor": "pointer"}} onClick={this.cleanUpFileWithDSSelect.bind(this)}>{i18next.t("cleanup")}</button>
												    </div>
												</div>
												: <Dropzone ref={dropzoneDSRef} onDrop={this.handleOnDropDS} multiple={false}>
							                        {({getRootProps, getInputProps}) => (
							                            <div {...getRootProps()} style={{cursor: "pointer"}} className="dropzone" id="dropDS">
							                                <input {...getInputProps()} />
							                                <p style={{cursor: "pointer", marginTop: "16px"}}>{i18next.t("dragNDropTitleSecond")}</p>
							                            </div>
							                        )}
							                    </Dropzone>
	                                    	}
	                                      </div>
	                                    
	                                }
                                </div>
                                <input id="fileWithDSUpload" type="file" onChange={this.onChangeDS.bind(this)} style={{"display": "none"}} />
                            </div>
                            {
                            	(!this.props.base.isLoading && this.props.defaultState.verifyResults !== null && this.props.defaultState.verifyResults.length > 0 && !this.props.defaultOptionState.showUpgradeCard)
                            	? <div className="row" style={{marginLeft: "0px", marginRight: "0px"}}>
                            		<div className="col-6 no-left-no-right-padding" style={{textAlign: "left", marginTop: "-10px", marginBottom: "10px"}}>
                            			{
                            				this.props.base.pdfReportEnabled === "true"
                            				? <span style={{cursor: "pointer", color: "#1a0dab", textAlign: "left"}} onClick={this.saveVerifyResultsToPdf}>{i18next.t("inspectionReport")}</span>
                            				: null
                            			}
		                        	</div>
                            		<div className="col-6 no-left-no-right-padding" style={{textAlign: "right", marginTop: "-10px", marginBottom: "10px"}}>
		                            	<span id="copyLink" style={{cursor: "pointer", color: "#1a0dab", textAlign: "right"}} onClick={this.copyVerifyResults}>{i18next.t("copyVerifyDSResultToClipboardTitle")}</span>
		                        	</div>
		                        </div>
                            	: null
                            }

                            {
                            	this.props.defaultOptionState.generateQR
                            	? (!this.props.base.isLoading && this.props.defaultState.verifyResults && this.props.defaultState.verifyResultsForQR) ? this.showDsVerifyResults(this.props.defaultState.verifyResults, this.props.defaultState.divId) : null
                            	: (!this.props.base.isLoading && this.props.defaultState.verifyResults) ? this.showDsVerifyResults(this.props.defaultState.verifyResults, this.props.defaultState.divId) : null
                            }

							<div className="row">
								<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 order-0 order-md-4">
			                        <button className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{marginBottom: "10px"}} onClick={this.setInputState.bind(this)} disabled={!isEnabled}>{this.props.defaultOptionState.showUpgradeCard ? i18next.t("ds:modifyDs") : i18next.t("ds:verifyDs")}
			                        	{
			                              	this.props.base.isLoading ? <span>&nbsp;<i className="fa fa-spinner fa-pulse"></i></span>
			                                : null
			                            }
			                        </button>
		                        </div>
		                        {
		                        	this.props.defaultOptionState.signatureType === 'attached' && !this.props.defaultOptionState.showUpgradeCard
		                        	? <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 order-1 row no-left-no-right-padding" style={{"marginLeft": "0px", "marginRight": "0px"}}>
		                        		{
		                        			this.props.base.previewEnabled === "true" && this.props.defaultState.fileSignedData && this.props.actions.checkExtensionVerify(this.props.defaultState.fileWithDSName)
		                        			? <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1"  style={{"paddingRight": "0px"}}><button className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{marginBottom: "10px"}} disabled={!isPreviewEnabled} onClick={this.showPreviewPopupVerify}><i className="fa fa-eye"></i></button></div>
		                        			: null
		                        		}
		                        		<div className={this.props.base.previewEnabled === "true" && this.props.defaultState.fileSignedData && this.props.actions.checkExtensionVerify(this.props.defaultState.fileWithDSName) ? "col-lg-11 col-md-11 col-sm-11 col-xs-11" : "col-lg-12 col-md-12 col-sm-12 col-xs-12"}><button className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{marginBottom: "10px"}} disabled={!isEnabledDownload} onClick={this.downloadSignedData.bind(this)}>{i18next.t("ds:saveSignedData")}</button></div>
		                        	</div>
		                        	: null
		                        }
		                        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 order-2 order-md-6 no-left-padding">
		                        	<button className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{marginBottom: "10px"}} onClick={this.cleanUpForm.bind(this)}>{i18next.t("cleanUpForm")}</button>
		                        </div>
	                        </div>
	                        <div className="row">
	                        	{
		                        	this.props.defaultOptionState.showUpgradeCard && (this.props.defaultState.differenceSignatureType !== null && this.props.defaultState.differenceSignatureType[0] !== undefined && this.props.defaultState.differenceSignatureType[0].previousSignatureFormat !== "CADES_X_LONG")
		                        	? <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
		                        		<button className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" disabled={!isEnabledDownloadModifiedDS} onClick={this.downloadModifiedData.bind(this)}>{i18next.t("ds:downloadModifiedDataTitle")}</button>
		                        	</div>
		                        	: null
		                        }
		                    </div>
		                    <div className="row">
	                        	{
		                        	this.props.defaultOptionState.showUpgradeCard && (this.props.defaultState.differenceSignatureType !== null && this.props.defaultState.differenceSignatureType[0] !== undefined && this.props.defaultState.differenceSignatureType[0].previousSignatureFormat !== "CADES_X_LONG")
		                        	? <div style={{marginTop: "10px"}} className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
		                        		<button className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" disabled={!isEnabledDownloadModifiedDS} onClick={this.verifyModifiedData.bind(this)}>{i18next.t("ds:verifyModifiedDataTitle")}</button>
		                        	</div>
		                        	: null
		                        }
		                    </div>
	                    </div>
	                    </div>
	                   </div>
	                   <VerifyTextDSContainer />
	                </div>
	                <div>
		                {
							this.props.base.showPreviewPopupVerify
							? <PreviewPopup file={this.props.defaultState.fileSignedData} />
							: null
						}
	                    {
	                        this.state.showPopup
	                        ? <QRPopup closeQRPopup={this.handleShowQR} data={this.state.displayedData} />
	                        : null
	                    }
	                    {
	                        this.state.showPrivateSignPopup
	                        ? <PrivateSignPopup closePrivateSignPopup={this.handleShowPrivateSign} data={this.state.displayedData} />
	                        : null
	                    }
	                </div>
	            </div>
	        </div>
		);
	}
}

function mapStateToProps(state) {
    return {
    	base: state.base,
        language: state.localesReducer.language,
        localesReducer: state.localesReducer,
        defaultState: state.verifyDSInputReducer,
        defaultOptionState: state.verifyDSOptionsReducer,
        mobileModeReducer: state.mobileModeReducer,
        expandedCardsReducer: state.expandedCardsReducer,
        upgradeReducer: state.upgradeDSReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
    	setVerifyInputFile,
    	setVerifyDSInputFile,
    	clearVerifyInputFile,
    	clearVerifyDSInputFile,
    	clearVerifyResultData,
    	clearFileSignedData,
    	setVerifyDSExpand,
    	clearModifiedDSData,
    	setIsLoading,
    	setSignatureDifferenceType,
    	clearSignatureDifferenceType,
    	checkExtensionVerify, setShowPreviewPopupVerify,
    	fromBytes, setShowUpgradeCard
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(VerifyDSTab);